import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// ui importing
import FormQuestionListRender from "./formQuestionListRender";

// css importing
import "./_index.css";

const FormQuestionList = () => {

  // TODO: urlLink
  const urlLink = window.location.pathname;

  // TODO: redux
  const dataRedux = useSelector((state: any) => state.appReducer.data);

  // TODO: state
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (urlLink.includes("student")) {
      setData(dataRedux.student);
    } else {
      setData(dataRedux.parrent);
    }
  }, [urlLink, dataRedux.student, dataRedux.parrent]);

  return (
    <div className="flex styled-scrollbars bg-blue-50 flex-col w-full p-3 h-max shadow-sm mt-12 space-y-10 overflow-auto rounded-sm">
      {/* question */}
      {data === null ? "" : <FormQuestionListRender data={data} />}
    </div>
  )
}

export default FormQuestionList;
